// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Assistant d'aide Centralis — bulle flottante et panneau de conversation.
 *
 * PALETTE FERMEE : orange primaire #f97316, texte #374151, gris #6b7280 / #9ca3af,
 * bordures #e5e7eb / #d1d5db, fonds #f9fafb / #fff7ed. Aucune couleur hors charte.
 *
 * RACINE A 62,5 % : dans ce projet, 1rem vaut 10px. Les valeurs en rem suivent cette
 * convention, comme le reste du CSS de l'application.
 *
 * AUCUNE CLASSE NE CONTIENT « overlay » NI « backdrop » : \`index.css\` fige le
 * defilement de la page entiere des qu'une classe portant l'une de ces sous-chaines
 * existe dans le document. Le widget etant monte en permanence, une telle classe
 * bloquerait le scroll du site pour de bon.
 *
 * EMPILEMENT : entre 9000 et 9997, soit sous les toasts (10000), sous le voile de
 * chargement (9998) et sous les modales bloquantes (99999). L'assistant est un
 * confort : il ne passe jamais devant une action en cours.
 */

.centralis-chat__pastille {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 9000;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.6rem;
  height: 5.6rem;
  border-radius: 50%;

  background: #f97316;
  color: #fff;
  border: none;
  box-shadow: 0 8px 24px -6px rgba(249, 115, 22, 0.5), 0 2px 6px rgba(15, 23, 42, 0.16);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.centralis-chat__pastille:hover {
  background: #ea580c;
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -6px rgba(249, 115, 22, 0.55), 0 3px 8px rgba(15, 23, 42, 0.2);
}

.centralis-chat__pastille:focus-visible {
  outline: 2px solid #f97316;
  outline-offset: 3px;
}

/* --- Panneau ------------------------------------------------------------- */

.centralis-chat {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 9000;

  display: flex;
  flex-direction: column;
  width: min(40rem, calc(100vw - 3rem));
  max-height: min(60rem, calc(100vh - 4rem));

  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 1.4rem;
  box-shadow: 0 16px 44px -8px rgba(15, 23, 42, 0.34), 0 6px 16px -4px rgba(15, 23, 42, 0.2);
  overflow: hidden;

  animation: centralis-chat-entree 0.22s ease-out;
}

@keyframes centralis-chat-entree {
  from { opacity: 0; transform: translateY(1.2rem); }
  to   { opacity: 1; transform: translateY(0); }
}

.centralis-chat__entete {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.4rem 1.6rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.centralis-chat__titre {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #595959;
}

.centralis-chat__sous-titre {
  margin: 0.2rem 0 0;
  font-size: 1.2rem;
  color: #6b7280;
}

.centralis-chat__fermer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  flex: none;
  border-radius: 0.6rem;
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.centralis-chat__fermer:hover { background: #e5e7eb; color: #374151; }
.centralis-chat__fermer:focus-visible { outline: 2px solid #f97316; outline-offset: 2px; }

/* --- Fil ----------------------------------------------------------------- */

.centralis-chat__fil {
  flex: 1 1;
  min-height: 22rem;
  overflow-y: auto;
  padding: 1.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #fff;
}

.centralis-chat__indisponible {
  margin: auto 0;
  padding: 2.4rem 1.6rem;
  text-align: center;
  font-size: 1.35rem;
  line-height: 1.6;
  color: #6b7280;
}

.centralis-chat__accueil {
  margin: 0;
  padding: 1.2rem 1.4rem;
  border-radius: 0.9rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 1.3rem;
  line-height: 1.5;
  color: #6b7280;
}

.centralis-chat__bulle {
  max-width: 85%;
  padding: 0.8rem 1.2rem;
  border-radius: 0.9rem;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.centralis-chat__bulle--assistant {
  align-self: flex-start;
  border-bottom-left-radius: 0.3rem;
  background: #f9fafb;
}

.centralis-chat__bulle--mienne {
  align-self: flex-end;
  background: #fff7ed;
  border-color: #fed7aa;
  border-bottom-right-radius: 0.3rem;
}

/* Une panne n'est pas une reponse : elle se distingue au premier coup d'oeil. */
.centralis-chat__bulle--erreur {
  align-self: stretch;
  max-width: 100%;
  background: #fef2f2;
  border-color: #fecaca;
}

.centralis-chat__auteur {
  display: block;
  font-size: 1.1rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.2rem;
}

.centralis-chat__bulle--mienne .centralis-chat__auteur { color: #f97316; }
.centralis-chat__bulle--erreur .centralis-chat__auteur { color: #dc2626; }

.centralis-chat__texte {
  margin: 0;
  font-size: 1.3rem;
  line-height: 1.5;
  color: #374151;
  /* Le contenu vient d'un modele de langue et n'est jamais interprete comme du HTML :
     les retours a la ligne sont rendus par le CSS, pas par des balises. */
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* --- Attente ------------------------------------------------------------- */

.centralis-chat__attente {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  align-self: flex-start;
  font-size: 1.25rem;
  color: #6b7280;
  padding: 0.4rem 0.2rem;
}

.centralis-chat__rotateur {
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  flex: none;
  border-radius: 50%;
  /* Anneau assez contraste pour que la rotation SE VOIE : a 18 px, un anneau trop
     pale donne l'impression d'un cercle immobile. */
  border: 2.5px solid rgba(15, 23, 42, 0.18);
  border-top-color: #f97316;
  animation: centralis-chat-rotation 0.7s linear infinite;
}

@keyframes centralis-chat-rotation {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* --- Saisie -------------------------------------------------------------- */

.centralis-chat__rotateur--bouton {
  width: 1.4rem;
  height: 1.4rem;
  border-color: rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
}

.centralis-chat__saisie {
  border-top: 1px solid #e5e7eb;
  padding: 1.2rem 1.6rem 1.4rem;
  background: #fff;
}

.centralis-chat__champ {
  width: 100%;
  min-height: 5rem;
  padding: 0.8rem 1rem;
  font-family: inherit;
  font-size: 1.3rem;
  line-height: 1.45;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
  resize: none;
}

.centralis-chat__champ:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
}

.centralis-chat__champ:disabled { background: #f9fafb; color: #9ca3af; }

.centralis-chat__barre {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.8rem;
}

.centralis-chat__compteur { font-size: 1.1rem; color: #9ca3af; }

/* Mention d'usage : discrete mais lisible, la ou l'utilisateur regarde avant d'envoyer. */
.centralis-chat__envoyer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  min-width: 11rem;
  padding: 0.8rem 2rem;
  border: none;
  border-radius: 0.8rem;
  background: #f97316;
  color: #fff;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.18s ease;
}

.centralis-chat__envoyer:hover:not(:disabled) { background: #ea580c; }
.centralis-chat__envoyer:focus-visible { outline: 2px solid #f97316; outline-offset: 2px; }
.centralis-chat__envoyer:disabled { background: #d1d5db; cursor: not-allowed; }

/* --- Petits ecrans ------------------------------------------------------- */

@media (max-width: 480px) {
  .centralis-chat {
    right: 1rem;
    left: 1rem;
    bottom: 1rem;
    width: auto;
    max-height: calc(100vh - 2rem);
  }

  .centralis-chat__pastille { right: 1rem; bottom: 1rem; }
}

@media (prefers-reduced-motion: reduce) {
  .centralis-chat,
  .centralis-chat__envoyer,
  .centralis-chat__fermer,
  .centralis-chat__pastille {
    animation: none;
    transition: none;
  }

  /* Le rotateur, LUI, continue de tourner — simplement plus lentement.
     \`prefers-reduced-motion\` vise le mouvement decoratif ; ici l'animation PORTE
     l'information « une reponse est en cours ». Un rotateur fige ne serait pas une
     animation en moins, ce serait un indicateur qui ment. */
  .centralis-chat__rotateur,
  .centralis-chat__rotateur--bouton {
    animation-duration: 1.6s;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/CentralisChat/Chat.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,aAAa;;EAEb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;;EAElB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sFAAsF;AACxF;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,0CAA0C;;EAE1C,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0FAA0F;EAC1F,gBAAgB;;EAEhB,+CAA+C;AACjD;;AAEA;EACE,OAAO,UAAU,EAAE,6BAA6B,EAAE;EAClD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yDAAyD;AAC3D;;AAEA,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,wCAAwC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEzF,8EAA8E;;AAE9E;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,yDAAyD,cAAc,EAAE;AACzE,yDAAyD,cAAc,EAAE;;AAEzE;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd;0EACwE;EACxE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB;oDACkD;EAClD,0CAA0C;EAC1C,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA,4BAA4B,iBAAiB,EAAE,cAAc,EAAE;;AAE/D,0FAA0F;AAC1F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA,gDAAgD,mBAAmB,EAAE;AACrE,yCAAyC,0BAA0B,EAAE,mBAAmB,EAAE;AAC1F,oCAAoC,mBAAmB,EAAE,mBAAmB,EAAE;;AAE9E,8EAA8E;;AAE9E;EACE;IACE,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,8BAA8B;EAChC;;EAEA,4BAA4B,WAAW,EAAE,YAAY,EAAE;AACzD;;AAEA;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;4DAG0D;EAC1D;;IAEE,wBAAwB;EAC1B;AACF","sourcesContent":["/*\n * Assistant d'aide Centralis — bulle flottante et panneau de conversation.\n *\n * PALETTE FERMEE : orange primaire #f97316, texte #374151, gris #6b7280 / #9ca3af,\n * bordures #e5e7eb / #d1d5db, fonds #f9fafb / #fff7ed. Aucune couleur hors charte.\n *\n * RACINE A 62,5 % : dans ce projet, 1rem vaut 10px. Les valeurs en rem suivent cette\n * convention, comme le reste du CSS de l'application.\n *\n * AUCUNE CLASSE NE CONTIENT « overlay » NI « backdrop » : `index.css` fige le\n * defilement de la page entiere des qu'une classe portant l'une de ces sous-chaines\n * existe dans le document. Le widget etant monte en permanence, une telle classe\n * bloquerait le scroll du site pour de bon.\n *\n * EMPILEMENT : entre 9000 et 9997, soit sous les toasts (10000), sous le voile de\n * chargement (9998) et sous les modales bloquantes (99999). L'assistant est un\n * confort : il ne passe jamais devant une action en cours.\n */\n\n.centralis-chat__pastille {\n  position: fixed;\n  bottom: 1.5rem;\n  right: 1.5rem;\n  z-index: 9000;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 5.6rem;\n  height: 5.6rem;\n  border-radius: 50%;\n\n  background: #f97316;\n  color: #fff;\n  border: none;\n  box-shadow: 0 8px 24px -6px rgba(249, 115, 22, 0.5), 0 2px 6px rgba(15, 23, 42, 0.16);\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;\n}\n\n.centralis-chat__pastille:hover {\n  background: #ea580c;\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px -6px rgba(249, 115, 22, 0.55), 0 3px 8px rgba(15, 23, 42, 0.2);\n}\n\n.centralis-chat__pastille:focus-visible {\n  outline: 2px solid #f97316;\n  outline-offset: 3px;\n}\n\n/* --- Panneau ------------------------------------------------------------- */\n\n.centralis-chat {\n  position: fixed;\n  bottom: 1.5rem;\n  right: 1.5rem;\n  z-index: 9000;\n\n  display: flex;\n  flex-direction: column;\n  width: min(40rem, calc(100vw - 3rem));\n  max-height: min(60rem, calc(100vh - 4rem));\n\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 1.4rem;\n  box-shadow: 0 16px 44px -8px rgba(15, 23, 42, 0.34), 0 6px 16px -4px rgba(15, 23, 42, 0.2);\n  overflow: hidden;\n\n  animation: centralis-chat-entree 0.22s ease-out;\n}\n\n@keyframes centralis-chat-entree {\n  from { opacity: 0; transform: translateY(1.2rem); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.centralis-chat__entete {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.4rem 1.6rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.centralis-chat__titre {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #595959;\n}\n\n.centralis-chat__sous-titre {\n  margin: 0.2rem 0 0;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n.centralis-chat__fermer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  flex: none;\n  border-radius: 0.6rem;\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.centralis-chat__fermer:hover { background: #e5e7eb; color: #374151; }\n.centralis-chat__fermer:focus-visible { outline: 2px solid #f97316; outline-offset: 2px; }\n\n/* --- Fil ----------------------------------------------------------------- */\n\n.centralis-chat__fil {\n  flex: 1;\n  min-height: 22rem;\n  overflow-y: auto;\n  padding: 1.4rem 1.6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background: #fff;\n}\n\n.centralis-chat__indisponible {\n  margin: auto 0;\n  padding: 2.4rem 1.6rem;\n  text-align: center;\n  font-size: 1.35rem;\n  line-height: 1.6;\n  color: #6b7280;\n}\n\n.centralis-chat__accueil {\n  margin: 0;\n  padding: 1.2rem 1.4rem;\n  border-radius: 0.9rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  font-size: 1.3rem;\n  line-height: 1.5;\n  color: #6b7280;\n}\n\n.centralis-chat__bulle {\n  max-width: 85%;\n  padding: 0.8rem 1.2rem;\n  border-radius: 0.9rem;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.centralis-chat__bulle--assistant {\n  align-self: flex-start;\n  border-bottom-left-radius: 0.3rem;\n  background: #f9fafb;\n}\n\n.centralis-chat__bulle--mienne {\n  align-self: flex-end;\n  background: #fff7ed;\n  border-color: #fed7aa;\n  border-bottom-right-radius: 0.3rem;\n}\n\n/* Une panne n'est pas une reponse : elle se distingue au premier coup d'oeil. */\n.centralis-chat__bulle--erreur {\n  align-self: stretch;\n  max-width: 100%;\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n.centralis-chat__auteur {\n  display: block;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 0.2rem;\n}\n\n.centralis-chat__bulle--mienne .centralis-chat__auteur { color: #f97316; }\n.centralis-chat__bulle--erreur .centralis-chat__auteur { color: #dc2626; }\n\n.centralis-chat__texte {\n  margin: 0;\n  font-size: 1.3rem;\n  line-height: 1.5;\n  color: #374151;\n  /* Le contenu vient d'un modele de langue et n'est jamais interprete comme du HTML :\n     les retours a la ligne sont rendus par le CSS, pas par des balises. */\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n/* --- Attente ------------------------------------------------------------- */\n\n.centralis-chat__attente {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  align-self: flex-start;\n  font-size: 1.25rem;\n  color: #6b7280;\n  padding: 0.4rem 0.2rem;\n}\n\n.centralis-chat__rotateur {\n  display: inline-block;\n  width: 1.8rem;\n  height: 1.8rem;\n  flex: none;\n  border-radius: 50%;\n  /* Anneau assez contraste pour que la rotation SE VOIE : a 18 px, un anneau trop\n     pale donne l'impression d'un cercle immobile. */\n  border: 2.5px solid rgba(15, 23, 42, 0.18);\n  border-top-color: #f97316;\n  animation: centralis-chat-rotation 0.7s linear infinite;\n}\n\n@keyframes centralis-chat-rotation {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n/* --- Saisie -------------------------------------------------------------- */\n\n.centralis-chat__rotateur--bouton {\n  width: 1.4rem;\n  height: 1.4rem;\n  border-color: rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n}\n\n.centralis-chat__saisie {\n  border-top: 1px solid #e5e7eb;\n  padding: 1.2rem 1.6rem 1.4rem;\n  background: #fff;\n}\n\n.centralis-chat__champ {\n  width: 100%;\n  min-height: 5rem;\n  padding: 0.8rem 1rem;\n  font-family: inherit;\n  font-size: 1.3rem;\n  line-height: 1.45;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n  resize: none;\n}\n\n.centralis-chat__champ:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n}\n\n.centralis-chat__champ:disabled { background: #f9fafb; color: #9ca3af; }\n\n.centralis-chat__barre {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 0.8rem;\n}\n\n.centralis-chat__compteur { font-size: 1.1rem; color: #9ca3af; }\n\n/* Mention d'usage : discrete mais lisible, la ou l'utilisateur regarde avant d'envoyer. */\n.centralis-chat__envoyer {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.7rem;\n  min-width: 11rem;\n  padding: 0.8rem 2rem;\n  border: none;\n  border-radius: 0.8rem;\n  background: #f97316;\n  color: #fff;\n  font-size: 1.3rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.18s ease;\n}\n\n.centralis-chat__envoyer:hover:not(:disabled) { background: #ea580c; }\n.centralis-chat__envoyer:focus-visible { outline: 2px solid #f97316; outline-offset: 2px; }\n.centralis-chat__envoyer:disabled { background: #d1d5db; cursor: not-allowed; }\n\n/* --- Petits ecrans ------------------------------------------------------- */\n\n@media (max-width: 480px) {\n  .centralis-chat {\n    right: 1rem;\n    left: 1rem;\n    bottom: 1rem;\n    width: auto;\n    max-height: calc(100vh - 2rem);\n  }\n\n  .centralis-chat__pastille { right: 1rem; bottom: 1rem; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .centralis-chat,\n  .centralis-chat__envoyer,\n  .centralis-chat__fermer,\n  .centralis-chat__pastille {\n    animation: none;\n    transition: none;\n  }\n\n  /* Le rotateur, LUI, continue de tourner — simplement plus lentement.\n     `prefers-reduced-motion` vise le mouvement decoratif ; ici l'animation PORTE\n     l'information « une reponse est en cours ». Un rotateur fige ne serait pas une\n     animation en moins, ce serait un indicateur qui ment. */\n  .centralis-chat__rotateur,\n  .centralis-chat__rotateur--bouton {\n    animation-duration: 1.6s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
